<template>
    <div>
        <div class="cotainer table-responsive bg-light p-2">
            <button class="btn-close float-end mt-3 me-3" @click.prevent="closeList"></button>
            <h3 class="mx-auto my-3 ">Clasificación de {{ sendProfileInfo.profileName }} / {{
                sendProfileInfo.profileSpecification }}</h3>
            <table class="table table-hover table-bordered my-1">
                <thead>
                    <tr>
                        <th scope="col">Nombre comercial</th>
                        <th scope="col">Nombre técnico</th>
                        <th scope="col">Altura total en mm</th>
                        <th scope="col">Ancho total en mm</th>
                        <th scope="col">Espesor del alma en mm</th>
                        <th scope="col">Espesor del ala en mm</th>
                        <th scope="col">Peso por metro</th>
                        <th scope="col">Precio Oxicorte</th>
                        <th scope="col">Precio Corte Plasma</th>
                        <th scope="col">Precio Corte Laser</th>
                        <th scope="col">Precio Sold. Elect.</th>
                        <th scope="col">Precio Sold. Mig</th>
                        <th scope="col">Precio Pnzd 1</th>
                        <th scope="col">Precio Pnzd 2</th>
                        <th scope="col">Precio Rolado R.</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="profile in profiles" :key="profile.id">
                        <th scope="row">
                        <td>{{ profile.tradeName }}</td>
                        </th>
                        <td>{{ profile.technicalName }}</td>
                        <td>{{ profile.height }}</td>
                        <td>{{ profile.width }}</td>
                        <td>{{ profile.thickness }}</td>
                        <td>{{ profile.thicknessWing }}</td>
                        <td>{{ profile.weightMeter }}</td>
                        <td>{{ profile.priceFlameCutting }}</td>
                        <td>{{ profile.pricePlasmaCutting }}</td>
                        <td>{{ profile.priceLaserCutting }}</td>
                        <td>{{ profile.priceWeldingElectrode }}</td>
                        <td>{{ profile.priceWeldingMig }}</td>
                        <td>{{ profile.pricePunching1 }}</td>
                        <td>{{ profile.pricePunching2 }}</td>
                        <td>{{ profile.priceRolled }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
    props: {
        sendProfileInfo: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            profiles: [],
        };
    },
    watch: {
        sendProfileInfo(newVal) {
            if (newVal !== null) {
                this.getProfileTypes();
            }
        },
    },
    methods: {
        closeList() {
            this.$emit("close-list")
        },
        async getProfileTypes() {
            try {
                if (!this.sendProfileInfo.profileId) {
                    console.log("Profile type id not defined.");
                    return;
                }
                const res = await axios.get(RUTA_SERVIDOR + "api/profile/type/list", {
                    params: {
                        profile_main_id: this.sendProfileInfo.profileId,
                    },
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                    },
                })
                    .then((res) => (this.profiles = res.data, console.log(this.profiles)))
                    .catch((err) => console.log(`There has been an error ${err}`));
            } catch (err) {
                console.log(`An error has occurred: ${err}`);
            }
        },
    },
    mounted() {
        // console.log(this.sendSheetInfo);
        this.getProfileTypes();
    },
};
</script>